/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

class FileSystemUtil {
  /**
   * Nalezne jednotku k uložení obsahu.
   * Zatím vždy vybere interní jednotku, u které očekává, že bude jediná přítomná tohoto typu.
   * Dočasná náhrada před implementací pokročilejšího výběru vhodných jednotek.
   * @param {FileSystemManager} fileSystemManager
   * @param {FileSystemUnitFinder} fileSystemUnitFinder
   * @param {LogicalUnitMapper} logicalUnitMapper
   * @returns {Promise<LogicalUnit|null>} Nalezená primární jednotka.
   */
  static async find(
    fileSystemManager,
    fileSystemUnitFinder,
    logicalUnitMapper
  ) {
    // Ziska vsechny dostupne jednotky
    const units = await fileSystemManager.getAllUnits();
    // Vyfiltruje jednotky dostupne pro ulozeni
    const unit = await fileSystemUnitFinder.find(units);
    if (isNil(unit)) {
      return null;
    }

    // Provede mapovani fyzickych jednotek na logicke
    return logicalUnitMapper.toLogical(unit);
  }
}

export default FileSystemUtil;
